import { Temperature } from "../Temperature";
import { LadderRate } from "./LadderRate";
import { PairPositions } from "./PairPositions";
import { OrderPosition } from "./OrderPosition";

export class LadderPair {
  #trackById: string;

  private _baseCode: string;
  private _nonBaseCode: string;
  private _isInvert: boolean = false;
  private _temperature: Temperature = Temperature.Cold;
  private _tradable: boolean = false;

  private _currentOrders: Set<string> = new Set();

  readonly dealtTracking = Number.MAX_VALUE;
  readonly fullWidth: boolean = true;

  aggregateId: string = null;

  associatedRate: LadderRate;
  selection: string;

  currentOrderPositions: PairPositions;

  public get isInvert(): boolean {
    return this._isInvert;
  }

  public set isInvert(value: boolean) {
    this._isInvert = value;
    this.#updateTrackBy();
  }

  public get baseCode(): string {
    return this._baseCode;
  }

  public set baseCode(value: string) {
    this._baseCode = value;
    this.#updateTrackBy();
  }

  public get nonBaseCode(): string {
    return this._nonBaseCode;
  }

  public set nonBaseCode(value: string) {
    this._nonBaseCode = value;
    this.#updateTrackBy();
  }

  public get temperature(): Temperature {
    return this._temperature;
  }

  public set temperature(value: Temperature) {
    this._temperature = value;
    this.#updateTrackBy();
  }

  public get tradable(): boolean {
    return this._tradable;
  }

  public set tradable(value: boolean) {
    this._tradable = value;
    this.#updateTrackBy();
  }

  public get pairIsEmpty(): boolean {
    return this._currentOrders.size === 0;
  }

  public get currentOrderCount(): number {
    return this._currentOrders.size;
  }

  public get currentOrders() {
    return this._currentOrders.values();
  }

  public addCurrentOrder(orderId: string) {
    this._currentOrders.add(orderId);
    this.#updateTrackBy();
  }

  public removeCurrentOrder(orderId: string) {
    this._currentOrders.delete(orderId);
    this.#updateTrackBy();
  }

  public clearCurrentOrders() {
    this._currentOrders.clear();
    this.#updateTrackBy();
  }

  public getAboveSortedPositions(): Array<OrderPosition> {
    if (this.currentOrderPositions) return this.currentOrderPositions.getAboveSortedPositions();
    return [];
  }

  public getBelowSortedPositions(): Array<OrderPosition> {
    if (this.currentOrderPositions) return this.currentOrderPositions.getBelowSortedPositions();
    return [];
  }

  #updateTrackBy() {
    this.#trackById = `${this.baseCode}${this.nonBaseCode}${this.temperature}${this.tradable}${this.isInvert}${this.currentOrderCount}`;
  }

  constructor() {
    this[Symbol.toPrimitive] = (_: string) => {
      return this.#trackById;
    };
  }
}
